/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationSyncFailedItemDtoSchema = z.object({
  failedAt: z.iso.datetime().describe('Timestamp when the failure was recorded.'),
  failedFields: z
    .object({})
    .catchall(z.string())
    .describe('Map of field name to error message. Null if the failure was not field-specific.')
    .nullish(),
  integrationId: z.int().describe('ID of the integration this failure belongs to.'),
  itemId: z
    .int()
    .describe(
      'Internal item ID. Null when the item failed during a create sync and was never persisted to item-store.',
    )
    .nullish(),
  message: z.string().describe('Human-readable description of why the sync failed.'),
  sourceItemKey: z.string().describe('Source system key (e.g. Jira issue key).').nullish(),
  syncDirection: z
    .enum(['PULL', 'PUSH'])
    .describe('Direction of the sync that failed: PULL (from source) or PUSH (to source).'),
  syncHistoryId: z
    .int()
    .describe(
      'ID of the sync run that produced this failure. Null if not associated with a specific run.',
    )
    .nullish(),
  type: z
    .enum(['TRANSIENT', 'PERMANENT', 'RECOVERABLE', 'UNKNOWN'])
    .describe(
      'Failure classification: TRANSIENT (retryable), PERMANENT (requires manual fix), UNKNOWN.',
    ),
});
